const vacancies = [
	{
		path: '/vacancies/list',
		name: 'jobs-vacancies-list',
		component: () => import(/* webpackChunkName: "VacanciesList" */ '@/views/jobs/vacancies/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},
	{
		path: '/vacancies/create',
		name: 'jobs-vacancies-create',
		component: () => import(/* webpackChunkName: "VacanciesCreate" */ '@/views/jobs/vacancies/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},
	{
		path: '/vacancies/edit/:id',
		name: 'jobs-vacancies-edit',
		component: () => import(/* webpackChunkName: "VacanciesCreate" */ '@/views/jobs/vacancies/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},
	{
		path: '/vacancies/:id/candidates',
		name: 'jobs-vacancies-candidates',
		component: () => import(/* webpackChunkName: "VacancyCandidates" */ '@/views/jobs/vacancies/candidates.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},

	{
		path: '/vacancies-status/list',
		name: 'jobs-vacancies-status-list',
		component: () => import(/* webpackChunkName: "VacanciesStatusList" */ '@/views/jobs/vacancies-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},

	{
		path: '/vacancy-titles/list',
		name: 'jobs-vacancy-titles-list',
		component: () => import(/* webpackChunkName: "VacanciesStatusList" */ '@/views/jobs/vacancy-titles/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},
]

export default vacancies
